import template from "./pCasemanIntegrationSettings.html";
import moment from "moment";

export function pCasemanIntegrationSettingsDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pCasemanIntegrationSettingsController,
    controllerAs: 'pCasemanIntegrationSettings',
    bindToController: true
  };

  return directive;
}

const FORM_GENERAL_FIELDS = [
  'strategy',
  'autoSyncMode',
  'autoSyncFrequency',
  'autoSyncDay',
  'everyAutoSyncWeekAt',
  'everyAutoSyncDayAt',
  'autoSyncScope',
  'autoSyncFrom',
  'countryAggregateType',
  'showJobInfoProcessGroups',
  'worklogMappersCustomization',
  'showJobInfoProcesses'
];

class pCasemanIntegrationSettingsController {
  constructor(Auth, Caseman, Notes, $interval, $scope, $translate, DownloadFile) {
    'ngInject';
    this.Auth = Auth;
    this.Caseman = Caseman;
    this.Notes = Notes;
    this.$interval = $interval;
    this.$scope = $scope;
    this.DownloadFile = DownloadFile;

    this.autoSyncMode = this.autoSyncModeDefault = false;
    this.showJobInfoProcessGroups = this.showJobInfoProcessGroupsDefault = false;
    this.showJobInfoProcesses = this.showJobInfoProcessesDefault = false;

    this.state = "loading";
    this.strategyOptions = [
      {
        id: 'All',
        name: $translate.instant("CASEMAN.ALL_TO_SETTLE")
      },
      {
        id: 'None',
        name: $translate.instant("CASEMAN.ALL_NOT_TO_SETTLE")
      },
      {
        id: 'VA',
        name: $translate.instant("CASEMAN.VA_TO_SETTLE_NVA_NOT")
      }
    ];

    this.weekdays = [
      {
        id: 1,
        label:"Monday"
      }, {
        id: 2,
        label: "Tuesday"
      }, {
        id: 3,
        label: "Wednesday"
      }, {
        id: 4,
        label: "Thursday"
      }, {
        id: 5,
        label: "Friday"
      }, {
        id: 6,
        label: "Saturday"
      }, {
        id: 7,
        label: "Sunday"
      }
    ];

    this.hours = [];

    for (let i = 0; i <= 23; i++) {
      const hour = i.toString().padStart(2, '0');
      this.hours.push(hour + ':00');
      this.hours.push(hour + ':30');
    }

    this.autoSyncScopeOptions = [
      {
        id: "AllReportedData",
        label: "All reported data"
      }, {
        id: "Day",
        label: "1 day"
      }, {
        id: "Week",
        label: "7 days"
      }, {
        id: "TwoWeeks",
        label: "14 days"
      }, {
        id: "Month",
        label: "30 days"
      }
    ];

    this.notValidAutoSyncScopeOptionsForWeek = ['AllReportedData', 'Day'];

    this.autoSyncScopeFromOptions = [
      {
        id: "Yesterday",
        label: "Yesterday"
      }, {
        id: "CurrentDay",
        label: "Current day"
      }
    ];

    this.$scope.$watch(() => this.autoSyncFrequency , (_, oldVal) => {
      if (oldVal) {
        this.autoSyncDay = null;
        this.everyAutoSyncWeekAt = null;
        this.everyAutoSyncDayAt = null;
      }
    });

    this.$scope.$watchGroup([
      () => this.autoSyncDay,
      () => this.everyAutoSyncWeekAt,
      () => this.everyAutoSyncDayAt,
      () => this.autoSyncFrom
    ], () => {
      if (this.autoSyncHourError)
        this.autoSyncHourError = false;

      if (this.autoSyncScopeError)
        this.autoSyncScopeError = false;
    });

    this.$scope.$watch(() => this.autoSyncScope, () => this.autoSyncScopeError && (this.autoSyncScopeError = false));

    this.Auth.authorize().then(
      (user) => {
        this.user = user;

        const timeout = this.$interval(() => { this.notes = this.Notes.getNotes();}, 200);
        this.$scope.$on("$destroy", () => {this.$interval.cancel( timeout );});

        this.getIntegrationStrategy();
      },
      () => {
        this.Auth.handleUnauthorized();
      }
    );
  }

  getIntegrationStrategy() {
    return this.Caseman.getIntegrationStrategy().then(
      (success) => {
        this.integrationSettings = success.data;
        this.strategy = this.strategyDefault = this.integrationSettings && this.integrationSettings.isPaidStrategy;
        this.state = "loaded";
        this.autoSyncMode = this.autoSyncModeDefault = Boolean(success.data.autoSyncAllUsers);
        this.usersWithAutoSync = success.data.userMappersCountryWithAutoSync;
        this.usersWithoutAutoSync = success.data.userMappersCountry - this.usersWithAutoSync;
        this.countryAggregateType = this.countryAggregateTypeDefault = success.data.countryAggregateType;
        this.userMappersCountryByAggregateTypes = success.data.userMappersCountryByAggregateTypes;
        this.showJobInfoProcessGroups = this.showJobInfoProcessGroupsDefault = Boolean(success.data.showJobInfoProcessGroups);
        this.showJobInfoProcesses = this.showJobInfoProcessesDefault = Boolean(success.data.showJobInfoProcesses);
        this.worklogMappersCustomization = this.worklogMappersCustomizationDefault = success.data.worklogMappersCustomization;
        this.autoSyncFrequency = this.autoSyncFrequencyDefault = success.data.autoSyncFrequency;
        this.autoSyncDay = this.autoSyncDayDefault = success.data.autoSyncDay
          && Object.values(this.weekdays).find(weekday =>
            weekday.label.toLowerCase() === success.data.autoSyncDay.toLowerCase()
          ).id.toString();
        this.autoSyncScope = this.autoSyncScopeDefault = success.data.autoSyncScope;
        this.autoSyncFrom = this.autoSyncFromDefault = success.data.autoSyncFrom;
        this.autoSyncWorklogsApprovedOnly = this.autoSyncWorklogsApprovedOnlyDefault = success.data.autoSyncWorklogsApprovedOnly;

        const autoSyncTime = success.data.autoSyncTime.slice(0, 5);
        if (this.autoSyncFrequency === 'Week')
          this.everyAutoSyncWeekAt = this.everyAutoSyncWeekAtDefault = this.hours.find(hour => hour === autoSyncTime);
        else
          this.everyAutoSyncDayAt = this.everyAutoSyncDayAtDefault = this.hours.find(hour => hour === autoSyncTime);
      },
      (error) => {
        this.state = "error";
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  saveStrategy() {
    if (this.autoSyncHourIsNotValid()) {
      this.autoSyncHourError = true;
      return;
    }

    if (this.autoSyncScopeIsNotValid()) {
      this.autoSyncScopeError = true;
      return;
    }

    this.state = "loading";
    const autoSyncDay = Object.values(this.weekdays).find(weekday => weekday.id == this.autoSyncDay);
    const data = {
      country: this.integrationSettings.countryCode,
      autoSyncAllUsers: this.autoSyncMode,
      aggregateTypeAllUsers: this.countryAggregateType,
      showJobInfoProcessGroups: this.showJobInfoProcessGroups,
      showJobInfoProcesses: this.showJobInfoProcesses,
      worklogMappersCustomization: this.worklogMappersCustomization,
      autoSyncWorklogsApprovedOnly: this.autoSyncWorklogsApprovedOnly,
      autoSyncScope: this.autoSyncScope,
      autoSyncFrom: this.autoSyncFrom,
      autoSyncDay: autoSyncDay && autoSyncDay.label.toUpperCase(),
      autoSyncTime: (this.autoSyncFrequency === 'Day' ? this.everyAutoSyncDayAt : this.everyAutoSyncWeekAt) + ":00",
      autoSyncFrequency: this.autoSyncFrequency
    };

    if (this.strategy !== this.integrationSettings.isPaidStrategy) {
      data.isPaidStrategy = this.strategy;
    }

    this.Caseman.saveIntegrationStrategy(data).then(
      () => {
        this.Notes.postNote({type: "success"});
        this.getIntegrationStrategy();
      },
      (error) => {
        this.state = "error";
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  exportIsDisabled() {
    return !this.dateStart || !this.dateEnd || moment(this.dateEnd).isBefore(this.dateStart);
  }

  exportSyncProblems() {
    this.state = "loading";
    this.Caseman.getExportSyncProblemsExcel({from: this.dateStart, to: this.dateEnd}).then(
      (success) => {
        this.DownloadFile.downloadFromResponse(
          success,
          success.headers('content-type'),
          `export-sync-problems-${this.dateStart}-${this.dateEnd}.xlsx`
        );
        this.state = "loaded";
      },
      (error) => {
        this.state = "error";
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  autoSyncHourIsNotValid() {
    return (
      this.autoSyncFrom === 'CurrentDay'
      && moment().day() === moment().day(this.autoSyncDay)
      && moment(this.everyAutoSyncWeekAt || this.everyAutoSyncDayAt, "hh:mm").isSameOrBefore(moment())
    );
  }

  autoSyncScopeIsNotValid() {
    return this.autoSyncFrequency === 'Week' && this.notValidAutoSyncScopeOptionsForWeek.includes(this.autoSyncScope);
  }

  isFormDisabled(form) {
    return (
      FORM_GENERAL_FIELDS.every(field => !form[field] || form[field].$modelValue == this[field + 'Default'])
      || form.autoSyncMode.$modelValue && (
        !form.autoSyncFrequency.$modelValue
        || !form.autoSyncScope.$modelValue
        || !form.autoSyncFrom.$modelValue
      )
      || form.autoSyncFrequency.$modelValue === 'Week' && (!this.autoSyncDay || !this.everyAutoSyncWeekAt)
      || form.autoSyncFrequency.$modelValue === 'Day' && !this.everyAutoSyncDayAt
      || this.autoSyncHourError
      || this.autoSyncScopeError
    );
  }
}
